import React from 'react';
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

/**
 * PurchaseInvoiceDetails component
 * Displays and manages purchase invoice details like invoice number, status, dates and payment status
 * 
 * @param {Object} props
 * @param {Object} props.invoice - The invoice data object
 * @param {Function} props.handleDateChange - Function to handle invoice date changes
 * @param {Function} props.handleSupplierInvoiceNoChange - Function to handle supplier invoice number changes
 * @param {Function} props.handlePaymentStatusChange - Function to handle payment status changes
 */
const PurchaseInvoiceDetails = ({ 
  invoice, 
  handleDateChange, 
  handleSupplierInvoiceNoChange,
  handlePaymentStatusChange 
}) => {
  return (
    <Grid container spacing={0.5}>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Invoice Number"
          value={invoice.invoiceNumber}
          fullWidth
          margin="dense"
          size="small"
          InputProps={{
            readOnly: true,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              height: 36,
            },
            '& .MuiInputBase-input': {
              py: 0.75,
              fontSize: '0.875rem'
            },
            '& .MuiInputLabel-root': {
              fontSize: '0.875rem'
            },
            '& .MuiSelect-select': {
              py: 0.75
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Status"
          value={invoice.status}
          fullWidth
          margin="dense"
          size="small"
          InputProps={{
            readOnly: true,
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              height: 36,
            },
            '& .MuiInputBase-input': {
              py: 0.75,
              fontSize: '0.875rem'
            },
            '& .MuiInputLabel-root': {
              fontSize: '0.875rem'
            },
            '& .MuiSelect-select': {
              py: 0.75
            }
          }}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="Invoice Date"
            value={invoice.date}
            onChange={handleDateChange}
            slotProps={{ 
              textField: { 
                fullWidth: true, 
                margin: "dense",
                size: "small",
                sx: {
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 0,
                    height: 36,
                  },
                  '& .MuiInputBase-input': {
                    py: 0.75,
                    fontSize: '0.875rem'
                  },
                  '& .MuiInputLabel-root': {
                    fontSize: '0.875rem'
                  },
                  '& .MuiSelect-select': {
                    py: 0.75
                  }
                }
              } 
            }}
          />
        </LocalizationProvider>
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Supplier Invoice No"
          value={invoice.supplierInvoiceNo || ''}
          onChange={(e) => handleSupplierInvoiceNoChange && handleSupplierInvoiceNoChange(e.target.value)}
          fullWidth
          margin="dense"
          size="small"
          placeholder="Enter supplier invoice number"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 0,
              height: 36,
            },
            '& .MuiInputBase-input': {
              py: 0.75,
              fontSize: '0.875rem'
            },
            '& .MuiInputLabel-root': {
              fontSize: '0.875rem'
            },
            '& .MuiSelect-select': {
              py: 0.75
            }
          }}
        />
      </Grid>
      {/* Payment Status field hidden - automatically calculated based on payments */}
      {/* <Grid item xs={12} sm={6}>
        <FormControl fullWidth margin="dense" size="small">
          <InputLabel sx={{ fontSize: '0.875rem' }}>Payment Status</InputLabel>
          <Select
            value={invoice.paymentStatus}
            onChange={handlePaymentStatusChange}
            label="Payment Status"
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: 0,
                height: 36,
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: 0,
              },
              '& .MuiSelect-select': {
                py: 0.75,
                fontSize: '0.875rem',
                borderRadius: 0,
              },
              '& .MuiInputLabel-root': {
                fontSize: '0.875rem'
              }
            }}
          >
            <MenuItem value="Partially Paid" sx={{ fontSize: '0.875rem' }}>
              <Box sx={{ color: '#4361ee', fontWeight: 500 }}>Partially Paid</Box>
            </MenuItem>
            <MenuItem value="Pending" sx={{ fontSize: '0.875rem' }}>
              <Box sx={{ color: '#ff5252', fontWeight: 500 }}>Pending</Box>
            </MenuItem>
            <MenuItem value="Paid" sx={{ fontSize: '0.875rem' }}>
              <Box sx={{ color: '#2ecd6f', fontWeight: 500 }}>Paid</Box>
            </MenuItem>
          </Select>
        </FormControl>
      </Grid> */}
    </Grid>
  );
};

export default PurchaseInvoiceDetails;
